export const exposiciones = [
    {
        "nombre" : "¡Extra, Extra! Hidalgo",
        "descripcion" : "Exposición Hemerográfica",
        "icono": "exposicion1.jpeg",
            
    },
    {
        "nombre" : "Contrastes de la vida cotidiana",
        "descripcion" : "Fotografías de principios del siglo XX",
        "icono": "exposicion2.jpeg",
     
    },
    {
        "nombre" : "El Estado en Pro de la Educación",
        "descripcion" : "Exposición documental",
        "icono": "exposicion3.jpeg",
      
    },
    
]